// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1JxyM","title":"BackImages_title__10kiZ","images":"BackImages_images__2iDXG"};